/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const swatchBtn = e.target.closest('.VariantSwatchInline__Btn');
    if (!swatchBtn) return;

    e.preventDefault();

    const value = swatchBtn.getAttribute('data-value');
    const optionContainer = swatchBtn.closest('.ProductForm__Option');
    if (!optionContainer) return;

    // Find the hidden ProductForm__Item button which acts as the activator for the popover
    const activator = optionContainer.querySelector('.ProductForm__Item');
    if (!activator) return;

    const popoverId = activator.getAttribute('aria-controls');
    if (!popoverId) return;

    const popover = document.getElementById(popoverId);
    if (!popover) return;

    // Find the button in the popover value list that matches this value
    const popoverValueBtn = Array.from(popover.querySelectorAll('.Popover__Value')).find(function(btn) {
      return btn.getAttribute('data-value') === value;
    });

    if (popoverValueBtn) {
      // Simulate click on the popover value button to trigger native change logic
      popoverValueBtn.click();

      // Update the inline swatch visual state
      const siblings = optionContainer.querySelectorAll('.VariantSwatchInline__Btn');
      siblings.forEach(function(btn) {
        if (btn === swatchBtn) {
          btn.classList.add('is-selected');
        } else {
          btn.classList.remove('is-selected');
        }
      });

      // Update the selected value label text in the header
      const selectedValueLabel = optionContainer.querySelector('.ProductForm__OptionHeader .ProductForm__SelectedValue');
      if (selectedValueLabel) {
        selectedValueLabel.textContent = value;
      }
    }
  });
});